/**
 * NOTE:
 * This only deters casual saving (right-click / drag). It cannot truly prevent
 * downloading because media must be delivered to the browser to be displayed.
 */
(() => {
  const shouldBlock = (target) => {
    if (!(target instanceof Element)) return false;
    return Boolean(target.closest('img, picture, video, [data-protect-media]'));
  };

  document.addEventListener(
    'contextmenu',
    (event) => {
      if (!shouldBlock(event.target)) return;
      event.preventDefault();
    },
    { capture: true }
  );

  document.addEventListener(
    'dragstart',
    (event) => {
      if (!shouldBlock(event.target)) return;
      event.preventDefault();
    },
    { capture: true }
  );

  // Makes "Save image as..." less convenient in some browsers.
  document.addEventListener(
    'mousedown',
    (event) => {
      if (event.button !== 2) return; // right mouse button
      if (!shouldBlock(event.target)) return;
      event.preventDefault();
    },
    { capture: true }
  );
})();

